import React, { useState, useEffect } from "react";

import { useStore } from "../../../Store";
import { PageLayoutWithGetData } from "../../Controls/PageLayout";
import Section from "../../Controls/Sections";
import { CancelContinueButtons } from "../../Controls/CancelContinueButtons";
import Helpers from "../../Functions/Helpers";
import { AiFillInfoCircle } from "react-icons/ai";
import { JointAccountPopUp, ClosedAccountPopUp } from "../PopUps";
import { useNavigate } from "react-router-dom";
import { AxiosRequestConfig } from "axios";
import {
  Box,
  Center,
  Heading,
  HStack,
  IconButton,
  Image,
  List,
  ListItem,
  Switch,
  Text,
} from "@chakra-ui/react";
import { BadgePill } from "../../BadgePill/BadgePill";
import { DetailsAccordion } from "../../Accordion/DetailsAccordion";

export default function SelectAccounts() {
  const navigate = useNavigate();

  const {
    data,
    selectedDataHolderBrand,
    selectedCustomer,
    setLoading,
    token,
    selectedDataHolder,
    setShowPopup,
    setShowPopupError,
    setPopupErrorMessage,
    selectedConsent,
  } = useStore();

  const [selectedAccountIds, setSelectedAccountIds] = useState<string[]>([]);

  const [showJointAccountPopUp, setShowJointAccountPopUp] = useState(false);
  const [showClosedAccountPopUp, setShowClosedAccountPopUp] = useState(false);

  const endpoint = process.env.REACT_APP_MOCK_API_BASE_URI;
  const headers = {
    Authorization: "Bearer " + token?.access_token,
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  function isAvailable(account: any) {
    return !(
      account?.jointAccountStatus?.toLowerCase() === "jamsdisabled" ||
      account?.openStatus?.toLowerCase() === "closed"
    );
  }

  function OnclickContinue() {
    setLoading(true);

    let payload = {
      softwareProductAcccId: data?.softwareProduct?.acccSoftwareProductId,
      softwareProductCustomerId: data?.customer?.softwareProductCustomerId,
      nameAndOccupationConsent: selectedConsent?.nameAndOccupationConsent,
      contactDetailsConsent: selectedConsent?.contactDetailsConsent,
      nameOccupationContactDetailsConsent:
        selectedConsent?.nameOccupationContactDetailsConsent,
      organisationProfileConsent: selectedConsent?.organisationProfileConsent,
      organisationContactDetailsConsent:
        selectedConsent?.organisationContactDetailsConsent,
      organisationProfileAndContactDetailsConsent:
        selectedConsent?.organisationProfileAndContactDetailsConsent,
      accountNameTypeAndBalanceConsent:
        selectedConsent?.accountNameTypeAndBalanceConsent,
      accountNumbersAndFeaturesConsent:
        selectedConsent?.accountNumbersAndFeaturesConsent,
      accountBalanceAndDetailsConsent:
        selectedConsent?.accountBalanceAndDetailsConsent,
      transactionDetailsConsent: selectedConsent?.transactionDetailsConsent,
      directDebitsAndScheduledPaymentsConsent:
        selectedConsent?.directDebitsAndScheduledPaymentsConsent,
      savedPayeesConsent: selectedConsent?.savedPayeesConsent,
      accountIds: selectedAccountIds,
    };

    const config: AxiosRequestConfig = {
      method: "post",
      url:
        endpoint +
        "/dataholderbrands/" +
        selectedDataHolder?.dataHolderBrandId +
        "/customers/" +
        selectedCustomer.dataholderBrandCustomerId +
        "/consents",
      headers: headers,
      data: payload,
    };

    Helpers.CallApi(
      config,
      (response) => {
        // Handle sucess
        navigate({
          pathname: "/DHAuthCallBack",
          hash:
            "#code=MOCK_code&id_token=MOCK_id_token&state=MOCK_state&cdr_arrangement_id=" +
            response.data.cdrArrangementId,
        });
      },
      (message) => {
        //handle error
        HandelError(message);
      }
    );
  }

  function HandelError(message: string) {
    setLoading(false);
    setShowPopup(false);
    setShowPopupError(true);
    setPopupErrorMessage(message);
  }

  const bankingAccounts: any[] = selectedCustomer?.bankingAccounts || [];

  const availableBankAccounts = bankingAccounts.filter(isAvailable);

  const hasSelectedAll =
    availableBankAccounts.length === selectedAccountIds.length;

  const hasUnavailableAccounts = bankingAccounts.some((a) => !isAvailable(a));

  return (
    <>
      <PageLayoutWithGetData
        backgroundColor={selectedDataHolderBrand?.backgroundColor}
        isMockBankScreen={true}
        hasContainerPadding={false}
      >
        <Box px={10} py={5}>
          <Box>
            <Center mt={4} mb={4}>
              <Image
                shadow="lg"
                maxH="300px"
                maxW="300px"
                borderRadius="xl"
                src={selectedDataHolderBrand?.logoUri}
                alt={selectedDataHolderBrand?.brandName + " Logo"}
              />
            </Center>

            <Heading variant="pageHeading">
              Please select accounts to share {selectedCustomer?.displayName}
            </Heading>

            <Text>
              <Text as="span" fontWeight="bold">
                {
                  data?.softwareProduct?.dataRecipientBrand?.dataRecipient
                    ?.legalEntityName
                }
              </Text>{" "}
              is requesting data from your accounts.
            </Text>

            <Text>
              Please select the accounts you would like to share data from.
            </Text>
          </Box>

          {/* Accounts available for sharing*/}
          {Boolean(availableBankAccounts.length) && (
            <Box mt={6}>
              <Box>
                <Heading fontSize="lg" id="AccountsAvailable">
                  Accounts available for sharing
                </Heading>

                <HStack justifyContent="flex-end" mb={2}>
                  <label
                    style={{ margin: 0, fontSize: 14 }}
                    htmlFor="selectAll"
                  >
                    Select All{" "}
                  </label>
                  <Switch
                    aria-label="Select All"
                    aria-labelledby="selectAll"
                    isChecked={hasSelectedAll}
                    onChange={() => {
                      if (hasSelectedAll) {
                        setSelectedAccountIds([]);
                      } else {
                        setSelectedAccountIds(
                          availableBankAccounts.map((a) => a.accountId)
                        );
                      }
                    }}
                  />
                </HStack>
              </Box>
              <Box>
                <List>
                  {availableBankAccounts.map((account: any) => {
                    const isSelected = selectedAccountIds.includes(
                      account.accountId
                    );
                    return (
                      <ListItem
                        key={account?.accountId}
                        style={{
                          backgroundColor:
                            selectedDataHolderBrand?.backgroundColor,
                        }}
                      >
                        <HStack justifyContent="space-between">
                          <Box>
                            <Heading fontSize="sm">
                              {account?.displayName}
                            </Heading>
                            <Text>{account?.maskedNumber}</Text>
                          </Box>

                          <Switch
                            isChecked={isSelected}
                            onChange={() => {
                              if (isSelected) {
                                setSelectedAccountIds((a) =>
                                  a.filter((a) => a !== account.accountId)
                                );
                              } else {
                                setSelectedAccountIds((a) => [
                                  ...a,
                                  account.accountId,
                                ]);
                              }
                            }}
                          />
                        </HStack>
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            </Box>
          )}

          {/* Accounts unavailable for sharing*/}
          {hasUnavailableAccounts && (
            <Box mt={6}>
              <DetailsAccordion
                title="Accounts unavailable for sharing"
                id="accordionAccounts"
              >
                <List w="full">
                  {(selectedCustomer?.bankingAccounts || [])
                    .filter((a: any) => !isAvailable(a))
                    .map((account: any) => (
                      <ListItem
                        key={account?.accountId}
                        style={{
                          backgroundColor:
                            selectedDataHolderBrand?.backgroundColor,
                        }}
                        py={2}
                      >
                        <HStack spacing={6} justifyContent="space-between">
                          <Box>
                            <Heading fontSize="sm">
                              {account?.displayName}
                            </Heading>
                            <Text>{account?.maskedNumber}</Text>
                          </Box>

                          {account?.openStatus.toLowerCase() === "closed" ? (
                            <HStack spacing={3}>
                              <BadgePill
                                label={"Closed Account"}
                                status={"danger"}
                              />
                              <IconButton
                                variant="ghost"
                                id="btnInfoClosedAccount"
                                onClick={() => setShowClosedAccountPopUp(true)}
                                icon={<AiFillInfoCircle size={30} />}
                                aria-label="Closed account info"
                              />
                            </HStack>
                          ) : account?.jointAccountStatus.toLowerCase() !==
                            "none" ? (
                            <HStack spacing={3}>
                              <BadgePill
                                label={"Joint Account"}
                                status={"secondary"}
                              />
                              <IconButton
                                variant="ghost"
                                id="btnInfoJointAccount"
                                onClick={() => setShowJointAccountPopUp(true)}
                                icon={<AiFillInfoCircle size={30} />}
                                aria-label="Joint account info"
                              />
                            </HStack>
                          ) : null}
                        </HStack>
                      </ListItem>
                    ))}
                </List>
              </DetailsAccordion>
            </Box>
          )}
        </Box>

        <JointAccountPopUp
          showPopup={showJointAccountPopUp}
          handleClose={() => setShowJointAccountPopUp(false)}
        />

        <ClosedAccountPopUp
          showPopup={showClosedAccountPopUp}
          handleClose={() => setShowClosedAccountPopUp(false)}
        />
        <Box height="20px" />
        <Section isGrey={true}>
          <Text fontWeight="bold" mt={2}>
            Do you confirm that we can share your data with{" "}
            {
              data?.softwareProduct?.dataRecipientBrand?.dataRecipient
                ?.legalEntityName
            }
          </Text>

          <CancelContinueButtons
            role="footer"
            btnDisableContinue={!selectedAccountIds.length}
            OnclickContinue={OnclickContinue}
            btnContinueText="I Confirm"
            btnCancelText="Cancel"
            step="SelectAccounts"
          />
        </Section>
      </PageLayoutWithGetData>
    </>
  );
}
